import { Layout } from "../components/Layout";
import { MyPaymentsTab } from "../components/MyPaymentsTab";

export default function MyPayments() {
	return (
		<Layout>
			<MyPaymentsTab />
		</Layout>
	);
}
